import type {
  TechStoriesSectionProps,
  TechStory,
} from "../_components/tech-stories/tech-stories";
import { FOOTER_FOOTNOTE_1 } from "./footer";
import { homeAsset } from "./home-assets";

export type { TechStory };

// durationMs below = the encoded clip length, so one progress fill = one video loop.
// `mobileFile` swaps in a different phone clip (e.g. the 4:5 cuts) for the default square one.
function techStoryVideo(
  n: string,
  mobileFile = `tech_story_${n}_mobile.mp4`,
): NonNullable<TechStory["video"]> {
  return {
    mp4: homeAsset(`tech_story_${n}.mp4`),
    mobileMp4: homeAsset(mobileFile),
    poster: homeAsset(`tech_story_${n}_poster.webp`),
  };
}

export const homeTechStoriesSectionProps: TechStoriesSectionProps = {
  title: (
    <>
      The most precise¹ hormone readings at
      home
    </>
  ),
  ctaLabel: "Watch Spectral Mapping film",
  stories: [
    {
      id: "spectral-mapping",
      title: (
        <>
          Patented Spectral Mapping Technology
          <sup className="text-[0.65em]">TM</sup>
        </>
      ),
      body: (
        <>
          Powered by Inito Spectral Mapping
          <sup className="text-[0.65em]">TM</sup> Technology, Inito delivers the
          most precise fertility hormone readings, outperforming other at-home
          tests in head-to-head lab testing.
        </>
      ),
      video: techStoryVideo("01"),
      durationMs: 15000,
    },
    {
      id: "four-hormones",
      title: "4 hormones. Measured separately",
      body: "Most monitors test multiple hormones on one track, where one hormone can interfere with another and make results less accurate. Inito measures hormones in four independent tracks, so every reading stays precise.",
      video: techStoryVideo("02", "4x5_3.mp4"),
      durationMs: 8400,
      mobileDurationMs: 8733,
    },
    {
      id: "subtle-shifts",
      title: "Subtle hormone shifts, precisely measured",
      body: "The only at-home monitor that double-checks every test with two sensing methods: fluorescence and visual colorimetric imaging. Designed to detect subtle hormone shifts that other tests can miss.",
      video: techStoryVideo("03", "4x5_1.mp4"),
      durationMs: 10066,
      mobileDurationMs: 9233,
    },
    {
      id: "richer-data",
      title: (
        <>
          Captures 100x <br />
          richer data
        </>
      ),
      body: "Inito captures a full 2D image of your entire test surface over time, collecting over 100× richer data from every test. That richer data helps our AI correct for real world variables — delivering lab-grade reliability at home.",
      video: techStoryVideo("04", "4x5_2.mp4"),
      durationMs: 5733,
      mobileDurationMs: 7533,
    },
  ],
  footnote: FOOTER_FOOTNOTE_1,
  film: {
    title: "Inito Spectral Mapping film",
    desktopMp4: homeAsset("tech_story_film_16x9.mp4"),
    mobileMp4: homeAsset("tech_story_film_4x5.mp4"),
  },
};
